import { Format, NumberFormatter } from '@zervant/reactcomponents'

import { store } from '../../store'

export const formatCurrency = (
  value: number,
  locale: string,
  currency: string | number,
  sign?: boolean,
  integer = false,
): string => {
  if (typeof value === 'number' && locale && currency) {
    const numberFormatter = new NumberFormatter(Format.fromLocale(locale))

    let formattedValue = numberFormatter.render(value, integer)

    if (!store.getState().config) {
      return `${formattedValue} ${currency}`
    }
    const cur = Object.values(store.getState().config.currencies).find((c) =>
      typeof currency === 'string' ? c.shortName === currency : c.id === currency,
    )

    const symbol = sign ? cur.symbol : currency
    if (cur.beforeAmount) {
      formattedValue = `${symbol} ${formattedValue}`
    } else {
      formattedValue = `${formattedValue} ${symbol}`
    }
    return formattedValue
  }
}
